import React from 'react';

export const FolderPlusIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      viewBox='0 0 55 44'
      focusable='false'
      width={width}
      height={height}
      className='icon icon-folder-plus'
      {...rest}
    >
      <path
        fill={fill}
        d='M51.5 9.5h-22L24 4H7.5a5.458 5.458 0 0 0-5.472 5.5L2 42.5A5.481 5.481 0 0 0 7.5 48h44a5.481 5.481 0 0 0 5.5-5.5V15a5.481 5.481 0 0 0-5.5-5.5zm-2.75 22H40.5v8.25H35V31.5h-8.25V26H35v-8.25h5.5V26h8.25z'
        transform='translate(-2 -4)'
      />
    </svg>
  );
};

FolderPlusIcon.defaultProps = {
  width: 55,
  height: 44,
  fill: '#3b86ff'
};
